<template>
  <div
    class="modal fade"
    id="modal_editar_chamada_publica"
    role="dialog"
    aria-labelledby="Modal Cadastro Chamada Pública"
    aria-hidden="true"
  >
    <div class="modal-dialog cascading-modal" role="document">
      <div class="modal-content">
        <div class="modal-header text-center">
          <h4 class="modal-title w-100 font-weight-bold">
            Cadastro de Chamada Públicas
          </h4>
          <button
            type="button"
            id="fecharInserirCard"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <form>
          <div class="modal-body mx-3">
            <div class="md-form form-sm">
              <label for="municipio">Município:</label>
              <select
                class="form-control"
                id="municipio"
                v-model="payload.municipioId"
                required
              >
                <option
                  v-for="municipio in municipios"
                  v-bind:value="municipio.municipioId"
                  v-bind:key="municipio.municipioId"
                >
                  {{ municipio.nome }}
                </option>
              </select>
            </div>

            <div class="md-form">
              <i class="fas fa-user prefix grey-text"></i>
              <label data-error="wrong" data-success="right" for="inicioString"
                >Início:</label
              >
              <input
                type="text"
                id="inicioString"
                class="form-control validate"
                v-mask="'##/##/####'"
                v-model="payload.inicioString"
              />
            </div>

            <div class="md-form">
              <i class="fas fa-user prefix grey-text"></i>
              <label data-error="wrong" data-success="right" for="termino"
                >Término:</label
              >
              <input
                type="text"
                id="termino"
                class="form-control validate"
                v-mask="'##/##/####'"
                v-model="payload.terminoString"
              />
            </div>

            <div class="md-form">
              <i class="fas fa-user prefix grey-text"></i>
              <label data-error="wrong" data-success="right" for="link"
                >Link:</label
              >
              <input
                type="text"
                id="link"
                class="form-control validate"
                v-model="payload.link"
              />
            </div>
          </div>

          <div class="modal-footer d-flex justify-content-center">
            <p>
              <button
                class="btn btn-info"
                style="height: unset;align-items: center"
                type="submit"
                @click="cadastrarChamadaPublica"
                v-if="!payload.chamadaPublicaId"
              >
                Cadastrar
              </button>
              <button
                class="btn btn-info"
                style="height: unset;align-items: center"
                type="submit"
                @click="cadastrarChamadaPublica"
                v-if="payload.chamadaPublicaId"
              >
                Atualizar
              </button>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { chamadaPublicaAPI, municipioAPI } from "@/modules/home";
export default {
  props: {
    payload: { type: Object, required: true }
  },
  data() {
    return {
      municipios: []
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    cadastrarChamadaPublica() {
      this.setLoading(true);
      chamadaPublicaAPI
        .update(this.payload)
        .then(resp => {
          this.setLoading(false);
          this.$toast.success("Chamada pública atualizada");
          this.$emit("atualizar-listagem");
        })
        .catch(resp => {
          this.setLoading(false);
          this.$toast.error("Erro ao atualizar chamada pública");
        });
    },
    listarMunicipios() {
      municipioAPI
        .list()
        .then(resp => {
          this.municipios = resp.data;
        })
        .catch(resp => {
          this.setLoading(false);
        });
    }
  },
  mounted() {
    this.listarMunicipios();
  }
};
</script>
